import { render, staticRenderFns } from "./DrcMenu.vue?vue&type=template&id=2eca06c4&scoped=true"
import script from "./DrcMenu.vue?vue&type=script&lang=js"
export * from "./DrcMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca06c4",
  null
  
)

export default component.exports